/* Kaayu shoppable mega menu - horizontal slider.
   Owner: snippets/kaayu-mega-products.liquid

   The panel itself is the theme's <mega-menu-horizontal> element; this only
   drives the product rail inside it. Progressive enhancement throughout: the
   rail is a plain overflow-x scroller, so it is already usable by touch,
   trackpad and keyboard before this file runs. The buttons are hidden by CSS
   until the class below is added, so they never appear as dead controls. */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(root) {
    var rail = root.querySelector('[data-khm-rail]');
    var prev = root.querySelector('[data-khm-prev]');
    var next = root.querySelector('[data-khm-next]');
    if (!rail || !prev || !next) return;

    function overflows() {
      return rail.scrollWidth - rail.clientWidth > 4;
    }

    function sync() {
      var max = rail.scrollWidth - rail.clientWidth;
      var x = rail.scrollLeft;
      root.classList.toggle('khm--scrollable', overflows());
      prev.disabled = x <= 2;
      next.disabled = x >= max - 2;
    }

    function page(dir) {
      // one "page" is most of the visible width, so the reader keeps a
      // reference item in view rather than jumping to a brand new set
      var step = Math.max(240, Math.round(rail.clientWidth * 0.8));
      rail.scrollBy({ left: dir * step, behavior: reduced ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); page(-1); });
    next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); page(1); });

    // the buttons sit inside a <details> summary region in some themes; make
    // sure a click on them never toggles the panel shut
    [prev, next].forEach(function (b) {
      b.addEventListener('mousedown', function (e) { e.preventDefault(); e.stopPropagation(); });
    });

    rail.addEventListener('scroll', sync, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(sync).observe(rail);
    window.addEventListener('resize', sync);

    // the panel is display:none until opened, so widths are only real once it
    // has been shown at least once
    var details = root.querySelector('details');
    if (details) details.addEventListener('toggle', function () { setTimeout(sync, 30); });

    sync();
    // images arrive late and change scrollWidth
    Array.prototype.forEach.call(rail.querySelectorAll('img'), function (img) {
      if (!img.complete) img.addEventListener('load', sync, { once: true });
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.khm'), setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
